<script>
	export let title;
	export let url;
</script>


<a class="btn" href={url} target="_blank">{title}</a>


<style>
	.btn {
        background-color: white;
		display: inline-block;

        width: 50%;
		padding: 1em 1.2em;
		margin: .5em;
		border-radius: 0.25em;
		box-sizing: border-box;

		color: black;
		text-align: center;
		text-decoration: none;

		transition:ease-out .2s;
	}

	.btn:hover {
		transition:ease-out .2s;
        width: 52%;
	}

</style>

